import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

function ColoredTitle ({ item, index }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ml: 4,
        p: 1,
        width: { md: '56%', xl: '50%' },
        height: { md: '80%', xl: '90%' },
        display: 'grid',
        backgroundColor: '#EEF5FF',
        position: 'relative',
        // border:1,
        [theme.breakpoints.down('md')]: {
          width: '100%',
          ml: 2,
          height: '8vh',
        },
      }}
    >
      <Typography
        component='div'
        sx={{
          lineHeight: '0.3',
          textAlign: 'left',
          color: index % 2 === 0 ? '#0a4fac' : '#fcaa0f',
          fontSize: { xs: '1.5rem', md: '2.65rem', xl: '2.5rem' },
          position: 'absolute',
          left: '-20%',
          fontWeight: 'bold',
          top: '25%',
          // border:1,
          [theme.breakpoints.down('md')]: {
            left: '-10%',
            top: 0,
          },
        }}
      >
        {item.highlight ? `RNR'S` : item.secondary}
        <Typography
          component='div'
          sx={{
            color: 'black',
            fontSize: { xs: '1.5rem', md: '2.65rem', xl: '2.5rem' },
            fontWeight: 'bold',
          }}
        >
          {item.name}
        </Typography>
      </Typography>

      <Box
        sx={{
          backgroundColor: index % 2 === 0 ? '#0a4fac' : '#fcaa0f',
          position: 'absolute',
          width: { md: '40px', xl: '50px' },
          height: { md: '40px', xl: '50px' },
          bottom: '-10%',
          right: '-10%',
          [theme.breakpoints.down('md')]: {
            width: '25px',
            height: '25px',
            right: '-5%',
            bottom: '-10%',
          },
        }}
      ></Box>
    </Box>
  );
}

export default ColoredTitle;
